var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseWithBlueSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1172 0.976562H4.88281C2.72545 0.976562 0.976562 2.72545 0.976562 4.88281V45.1172C0.976562 47.2746 2.72545 49.0234 4.88281 49.0234H45.1172C47.2746 49.0234 49.0234 47.2746 49.0234 45.1172V4.88281C49.0234 2.72545 47.2746 0.976562 45.1172 0.976562Z",
    fill: "#667CA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4844 26.3662L16.3594 34.4912L14.5547 32.6847L22.6788 24.5605L14.5547 16.4359L16.3598 14.6309L24.4848 22.755L32.6085 14.6309L34.4151 16.4359L26.2901 24.5609L34.4151 32.6851L32.6085 34.4917L24.4844 26.3662Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWithBlueSquare);
export default __webpack_public_path__ + "static/media/close_with_blue_square.4fb30ba34a45abdb3130745d28c814bb.svg";
export { ForwardRef as ReactComponent };